import LegalLayout from "@/components/layout/LegalLayout";

const SECTIONS = [
    {
        h: "1. Administrator danych",
        p: [
            "Administratorem Twoich danych osobowych jest Groszownik (dane rejestrowe oraz kontaktowe zostaną uzupełnione przed premierą).",
        ],
    },
    {
        h: "2. Jakie dane przetwarzamy",
        p: [
            "Na tej stronie przetwarzamy adres e-mail podany dobrowolnie w formularzu listy oczekujących oraz informację o wyrażonej zgodzie marketingowej.",
            "Jeśli włączymy narzędzia analityczne (np. Google Analytics 4, Microsoft Clarity), możemy przetwarzać dane o korzystaniu ze strony w formie zpseudonimizowanej, na podstawie Twojej zgody wyrażonej w banerze cookies.",
        ],
    },
    {
        h: "3. Cel i podstawa przetwarzania",
        p: [
            "Adres e-mail przetwarzamy w celu poinformowania Cię o premierze aplikacji (podstawa: Twoja zgoda, art. 6 ust. 1 lit. a RODO).",
            "Dane analityczne przetwarzamy w celu ulepszania strony (podstawa: zgoda lub nasz prawnie uzasadniony interes).",
        ],
    },
    {
        h: "4. Twoje prawa",
        p: [
            "Masz prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia oraz wniesienia sprzeciwu. Zgodę możesz wycofać w każdej chwili — dane kontaktowe do realizacji tych praw udostępnimy przed premierą.",
            "Przysługuje Ci również prawo wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych.",
        ],
    },
    {
        h: "5. Okres przechowywania",
        p: [
            "Adres e-mail przechowujemy do momentu wycofania zgody lub premiery aplikacji i migracji do systemu docelowego. Dane analityczne — zgodnie z ustawieniami danego narzędzia.",
        ],
    },
    {
        h: "6. Odbiorcy i transfer",
        p: [
            "Dane przechowujemy na serwerach w Unii Europejskiej. Możemy korzystać z zaufanych dostawców (hosting, wysyłka e-mail), którzy przetwarzają dane wyłącznie na nasze polecenie.",
        ],
    },
];

export default function PrivacyPage() {
    return (
        <LegalLayout
            title="Polityka prywatności"
            path="/polityka-prywatnosci"
            description="Polityka prywatności serwisu Groszownik — jak przetwarzamy Twoje dane osobowe zgodnie z RODO."
            updated="12 lipca 2026"
            sections={SECTIONS}
        />
    );
}
